import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_comp_branch_location_entity_link_RowCLass} from '../../../dbschema/bl_fi_mst_comp_branch_location_entity_link.model';

export class CompBranchLocationEntityLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_comp_branch_location_entity_link:
    bl_fi_mst_comp_branch_location_entity_link_RowCLass = new bl_fi_mst_comp_branch_location_entity_link_RowCLass();
}
